import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { FeaturesState } from './+store/features.state';



@NgModule({
    declarations: [],
    imports: [CommonModule, NgxsModule.forFeature([FeaturesState])]
})
export class FeaturesModule { }

export { FeaturesResolverService } from './resolvers/features-resolver.service'
export { FeaturesFacade } from './+store/features.facade'